var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[_c('router-view'),_c('Concat'),_c('Footer',{directives:[{name:"show",rawName:"v-show",value:(_vm.getIsShowHeaderAndFooter),expression:"getIsShowHeaderAndFooter"}],ref:"footer"})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }